module.exports = __webpack_public_path__ + "static/media/MediumScoreGirl.65bfa295.svg";